var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-parallax',{attrs:{"src":require("../../assets/fightbanner.jpg"),"height":"200"}},[_c('v-row',[_c('v-col',{staticClass:"col-12 my-auto text-center"},[_c('h2',{staticClass:"bannerheadingh2"},[_vm._v("Current Fights")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }